// This file was generated by https://github.com/redbubble/design/blob/master/scripts/generateIcons.js
import React from 'react';
import Icon from '../Icon';

const ExternalLinkIcon = props => <Icon {...props} dangerouslySetIcon={'<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path d="M16 22H5a3 3 0 01-3-3V8a3 3 0 013-3h6a1 1 0 010 2H5a1 1 0 00-1 1v11a1 1 0 001 1h11a1 1 0 001-1v-6a1 1 0 012 0v6a3 3 0 01-3 3z"/><path d="M21.92 2.62a1 1 0 00-.54-.54A1 1 0 0021 2h-6a1 1 0 000 2h3.59l-9.3 9.29a1 1 0 000 1.42 1 1 0 001.42 0L20 5.41V9a1 1 0 002 0V3a1 1 0 00-.08-.38z"/></svg>'} />;

ExternalLinkIcon.displayName = 'ExternalLinkIcon';

export default ExternalLinkIcon;
